import React from 'react'
import "./Courses-style.css"
// import html5 from "./html5.jpeg"
// import css from "./css.jpeg"
// import js from "./js.png"

export default function Courses() {
  return (
    <>
      <section id="main">
        <div id="list-of-courses">
          <div className="heading"><h1><span>Protonity</span> Best Learner Choice Courses</h1></div>
          <div className="courses">
            <div className="course-one">
              <h2>All About HTML5</h2>
              <p>HTML5 is a markup language used for structuring 
                and presenting content on the World Wide Web. It 
                is the fifth and final major HTML version that is
                 a World Wide Web Consortium (W3C) recommendation.
                  The current specification is known as the HTML 
                  Living Standard.</p>
                <div><button>+Add Course</button></div>
              
            </div>


            {/* Second Course Start here */}

            <div className="course-one">
              <h2>All About CSS3</h2>
              <p>CSS3 is the latest version of the CSS specification. 
                CSS3 adds several new styling features and improvements 
                to enhance the web presentation capabilities. Note: Our 
                CSS tutorial will help you to learn the fundamentals of 
                the latest CSS3 language, from the basic to advanced 
                topics step-by-step.</p>
                <div><button>+Add Course</button></div>
            </div>

            {/* Third course Start Here  */}

            <div className="course-one">
              <h2>From Basic To Expert JavaScript</h2>
              <p>JavaScript, often abbreviated JS, is a programming
                 language that is one of the core technologies of
                  the World Wide Web, alongside HTML and CSS. Over 97% of
                   websites use JavaScript on the client side for web page 
                behavior, often incorporating third-party libraries.</p>
                <div><button>+Add Course</button></div>
            </div>

          </div>
        </div>
      </section>




    </>
  )
}
